import React, { useEffect, useState } from "react";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { supabase } from "./supabaseClient";
import Layout from "./screens/Layout.jsx";
import ErrorPage from "./screens/ErrorPage.jsx";
import Landing from "./screens/Landing.jsx";
import CourseDetails from "./screens/CourseDetails.jsx";
import Success from "./screens/SuccessPage.jsx";
import StockMarketBasics from "./components/Payment/StockMarketBasics.jsx";
import Contact from "./components/Sections/Contact.jsx";
import Payment from "./components/Payment/PaymentComponent.jsx";
import FundamentalAnalysis from "./components/Payment/FundamentalAnalysis.jsx";
import TechnicalAnalysis from "./components/Payment/TechnicalAnalysis.jsx";
import CourseReview from "./screens/CourseReview.jsx";
import Terms from "./screens/Terms.jsx";
import Privacy from "./screens/Privacy.jsx";
import Refund from "./screens/Refund.jsx";
import ProInvestor from "./screens/ProInvestor.jsx";
import CourseDetail from "./components/Payment/CourseDetail.jsx";
import { useParams } from "react-router-dom";

function CourseDetailLoader({ courses, loading }) {
  const { id } = useParams();
  const course = courses.find((c) => String(c.id) === String(id));
  return <CourseDetail course={course} loading={loading} />;
}

function App() {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCourses = async () => {
      const { data, error } = await supabase
        .from("courses")
        .select("*")
        .order("position");
      if (!error) setCourses(data);
      setLoading(false);
    };
    fetchCourses();
  }, []);

  const basicsCourse = courses.find((c) => c.title === "Stock Market Basics");
  const fundamentalCourse = courses.find(
    (c) => c.title === "Fundamental Analysis"
  );
  const technicalCourse = courses.find((c) => c.title === "Technical Analysis");
  const allThreeCourse = courses.find(
    (c) => c.title === "Basics + Fundamental + Technical"
  );

  const basicPrice = basicsCourse?.price || 1700;
  const fundamentalPrice = fundamentalCourse?.price || 3500;
  const technicalPrice = technicalCourse?.price || 2500;
  const allThreePrice = allThreeCourse?.price || 6500;

  const router = createBrowserRouter([
    {
      path: "/",
      element: <Layout />,
      errorElement: <ErrorPage />,
      children: [
        {
          path: "/",
          element: <Landing />,
        },
        {
          path: "/courses",
          element: <CourseDetails courses={courses} loading={loading} />,
        },
        {
          path: "/coursereview",
          element: <CourseReview />,
        },
        {
          path: "/course/:id",
          element: <CourseDetailLoader courses={courses} loading={loading} />,
        },
        {
          path: "/stockmarketbasics",
          element: (
            <StockMarketBasics course={basicsCourse} loading={loading} />
          ),
        },
        {
          path: "/fundamentalanalysis",
          element: (
            <FundamentalAnalysis course={fundamentalCourse} loading={loading} />
          ),
        },
        {
          path: "/technicalanalysis",
          element: (
            <TechnicalAnalysis course={technicalCourse} loading={loading} />
          ),
        },
        {
          path: "/payment-info",
          element: (
            <Payment
              basicPrice={basicPrice}
              fundamentalPrice={fundamentalPrice}
              technicalPrice={technicalPrice}
              allThreePrice={allThreePrice}
            />
          ),
        },
        {
          path: "/contact",
          element: <Contact />,
        },
        {
          path: "/terms&conditions",
          element: <Terms />,
        },
        {
          path: "/privacypolicy",
          element: <Privacy />,
        },
        {
          path: "/refundpolicy",
          element: <Refund />,
        },
        {
          path: "/success",
          element: <Success />,
        },
        {
          path: "/proinvestor",
          element: <ProInvestor />,
        },
      ],
    },
  ]);

  return (
    <>
      <RouterProvider router={router} />
    </>
  );
}
export default App;
